document
  .getElementById('forgotten-password-toggle')
  ?.addEventListener('click', function () {
    const dropdown = document.getElementById('forgotten-password')
    if (dropdown.style.maxHeight) {
      dropdown.style.maxHeight = null
    } else {
      dropdown.style.maxHeight = dropdown.scrollHeight + 'px'
    }

    dropdown.querySelector('input[type=email]').focus()
    dropdown.scrollIntoView({ behavior: 'smooth' })
  })
